import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { useDispatch, useSelector } from "react-redux";
import { getNews, deleteNewsData } from "../../../actions/adminNewsActions";

import Loader from "../../Loader";
import { newsImageUrl } from "../../../utils/assets";

// Helper function to strip HTML tags and decode entities for display
const stripHtml = (html) => {
  if (!html) return '';
  // Create a temporary element to decode HTML entities
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  // Get text content and truncate
  const text = tmp.textContent || tmp.innerText || '';
  return text.length > 150 ? text.substring(0, 150) + '...' : text;
};

const ListNews = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const handleDeleteNews = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteNewsData(id));
            // history.push(`/admin/news-list`);
            alert.success("News deleted successfully");
            dispatch(getNews());
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  useEffect(() => {
    dispatch(getNews());
  }, [dispatch]);

  const { news, nloading } = useSelector((state) => state.newsList);

  return (
    <Fragment>
      {nloading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small>News</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li className="active">News</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">News</h3>
                      <div className="box-tools">
                        <Link
                          to={"/admin/news-list/add"}
                          className="btn btn-success btn-sm"
                        >
                          + Add News
                        </Link>
                      </div>
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th style={{ maxWidth: '400px' }}>Description</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {news.nloading ? (
                            <Loader />
                          ) : news !== undefined && news.length ? (
                            news.map((item) => (
                              <tr key={item._id}>
                                <td><strong>{item.title}</strong></td>
                                <td style={{ maxWidth: '400px' }}>{stripHtml(item.description)}</td>
                                <td>
                                  {item.logo ? (
                                    <img
                                      style={{ width: "80px", height: "60px", objectFit: "cover" }}
                                      src={newsImageUrl(item.logo)}
                                      alt="News"
                                      crossOrigin="anonymous"
                                      onError={(e) => {
                                        if (!e.target.dataset.fallback) {
                                          e.target.dataset.fallback = '1';
                                          e.target.style.display = 'none';
                                          e.target.insertAdjacentHTML('afterend', '<span class="text-muted" style="font-size:12px">Image unavailable</span>');
                                        }
                                      }}
                                    />
                                  ) : (
                                    <span className="text-muted">No image</span>
                                  )}
                                </td>
                                <td>
                                  {item.status === true && (
                                    <span className="badge bg-green">
                                      Active
                                    </span>
                                  )}
                                  {item.status === false && (
                                    <span className="badge bg-yellow">
                                      InActive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to={`/admin/news-list/edit/${item._id}`}
                                    className="btn btn-success btn-sm"
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Link>
                                  &nbsp;
                                  <a
                                    className="btn btn-danger btn-sm"
                                    title="Delete"
                                    onClick={() => handleDeleteNews(item._id)}
                                    key={item._id}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">No records found</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListNews;
